<ng-container>
  <div class="formControl mt">
    <div class="row d-flex align-items-center">
      <div class="col col-md-6">
        <question-description
          titleDir="left"
          subTitleDir="left"
          title="Dégagez-vous un résultat positif net avant impôt ?"
          [titleStyle]="{ fontSize: '16px' }"
        >
        </question-description>
      </div>
      <div class="col col-md-6 clear-m">
        <pr-input-radio
          formControlName="resultatNet"
          direction="column"
          [isDefault]="false"
          [toggle]="true"
          [options]="options"
        >
        </pr-input-radio>
      </div>
    </div>
    <div class="row d-flex align-items-center">
      <div class="col col-md-6">
        <question-description
          titleDir="left"
          subTitleDir="left"
          title="Avez-vous un leasing en cours ?"
          [titleStyle]="{ fontSize: '16px' }"
        >
        </question-description>
      </div>
      <div class="col col-md-6 clear-m">
        <pr-input-radio
          formControlName="leasing"
          direction="column"
          [isDefault]="false"
          [toggle]="true"
          [options]="options"
        >
        </pr-input-radio>
      </div>
    </div>

    <div class="row d-flex align-items-center">
      <div class="col col-md-6">
        <question-description
          titleDir="left"
          subTitleDir="left"
          title="Avez-vous de la trésorerie long terme à placer (> 5 ans) ?"
          [titleStyle]="{ fontSize: '16px' }"
        >
        </question-description>
      </div>
      <div class="col col-md-6 clear-m">
        <pr-input-radio
          formControlName="tresorerieAPlacer"
          direction="column"
          [isDefault]="false"
          [toggle]="true"
          [options]="options"
        >
        </pr-input-radio>
      </div>
    </div>
  </div>
</ng-container>
